"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { InitMuiLicense, Spinner } from "@climatepartner/components";
import { AuthProvider, useAuth } from "@climatepartner/hooks";
import { getServiceUrls, mapServiceUrlsByAccess } from "@climatepartner/utils";
import { AuthenticationContext, AuthenticationProvider } from "../../providers/AuthenticationContext";
import { DashboardLayout } from "./DashboardLayout";
InitMuiLicense();
const POST_LOGOUT_REDIRECT_URI = "https://climatepartner.com";
const FronteggAuthProvider = (props) => {
    const { children, fronteggEnvironment } = props;
    const isEmployeeLogin = false;
    const { user: fronteggUser, isAuthenticated, hasPermission, logout } = useAuth(isEmployeeLogin);
    if (fronteggUser === null || !isAuthenticated) {
        return _jsx(Spinner, { isFixed: true });
    }
    const oidcConfig = {};
    const { id, name, email, accessToken } = fronteggUser;
    const user = {
        id,
        name,
        email,
        givenName: name,
        familyName: name,
        resourceAccess: {},
        isCpEmployee: isEmployeeLogin,
    };
    const decodedAccessToken = {
        name,
        email,
        preferred_username: name,
        given_name: name,
        family_name: name,
        iss: "not-available-for-frontegg",
        sub: "not-available-for-frontegg",
        resource_access: {},
    };
    const state = {
        user,
        isAuthenticated,
        decodedAccessToken,
        accessToken,
        accessTokenExp: 0,
        refreshToken: "does-not-apply-to-frontegg-because-frontegg-handles-refresh",
        refreshTokenExp: 0,
    };
    const actions = {
        logout: () => logout(POST_LOGOUT_REDIRECT_URI),
        refreshAccessToken: async () => { },
        hasPermission,
    };
    const serviceUrls = getServiceUrls({ env: fronteggEnvironment, userHasPermission: hasPermission });
    const enabledServices = mapServiceUrlsByAccess(serviceUrls);
    return (_jsx(AuthenticationContext.Provider, { value: { oidcConfig, state, actions, enabledServices }, children: children }));
};
export function AppShell(props) {
    const { oidcConfig, authProvider = "keycloak", children, fronteggEnvironment } = props;
    if (authProvider === "frontegg") {
        if (fronteggEnvironment !== undefined && ["dev", "staging", "prod"].includes(fronteggEnvironment)) {
            return (_jsx(AuthProvider, { environment: fronteggEnvironment, children: _jsx(FronteggAuthProvider, { fronteggEnvironment: fronteggEnvironment, children: _jsx(DashboardLayout, { ...props, children: children }) }) }));
        }
        throw new Error("Frontegg environment needs to be set to dev, staging or prod.");
    }
    return (_jsx(AuthenticationProvider, { oidcConfig: oidcConfig, children: _jsx(DashboardLayout, { ...props, children: children }) }));
}
export default AppShell;
//# sourceMappingURL=AppShell.js.map